import type { MutableRefObject } from 'react';

import { useCallback } from 'react';

export function useSchedulePersist(
  persistChainRef: MutableRefObject<Promise<unknown>>,
): (run: () => Promise<void>) => Promise<unknown> {
  return useCallback((run: () => Promise<void>) => {
    const next = persistChainRef.current.then(run).catch(() => undefined);
    persistChainRef.current = next;
    return next;
  }, []);
}
